<section class="header-info">
  <div class="title-share" mat-dialog-title>
    <span>Compartilhar</span>
  </div>

  <div class="wrapper-share">

    <p>A SigAlerta é uma idealização da Secretaria de Meio Ambiente do Mato Grosso,
      desenvolvido pela empresa Solved - Soluções em Geoinformação, com recursos do Programa REDD Early Movers - REM:</p>

    <img src="/assets/img/header/sema-logo.svg" alt="share-sema-icon" style="padding: 5em 0.4em; width: 30%;" />

    <img src="/assets/img/header/share-solved-icon.svg" alt="share-solved-icon" style="padding: 5em 0.4em; width: 30%;" />

    <img src="/assets/img/header/share-logo-rem.png" alt="share-solved-icon" style="padding: 5em 0.4em; width: 25%;" />

  </div>
</section>
